import { HttpClient, HttpStatusCode } from '../protocols/http'
import { LoadWorkList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { Work } from '@/javascript/domain/entities/work'

export class RemoteLoadWorkList implements LoadWorkList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadWorkList.Response>
  ) {}

  async load(params?: LoadWorkList.Params): Promise<Work[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: params?.searchText,
        include_team_works: params?.includeTeamWorks,
        include_resource_places: params?.includeResourcePlaces,
        'statuses[]': params?.statuses,
        without_route: params?.withoutRoute
      }
    })
    const result = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatData(result)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadWorkList {
  export type Work = {
    id: number
    title: string
    start_time: string
    end_time: string
    resource_place?: {
      name: string
      address?: string
      hierarchy_address?: string
      hierarchy_latitude?: number
      hierarchy_longitude?: number
    }
  }
  export type Response = {
    results?: Work[]
  }
}

const formatData = (response: RemoteLoadWorkList.Response): Work[] => {
  return response?.results?.map(work => ({
    id: work.id,
    title: work.title,
    startTime: work.start_time,
    endTime: work.end_time,
    resourcePlace: work.resource_place ? {
      name: work.resource_place.name,
      address: work.resource_place.hierarchy_address,
      latitude: work.resource_place.hierarchy_latitude,
      longitude: work.resource_place.hierarchy_longitude
    } : undefined
  })) || []
}
